import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectDto } from '@admin/models/project-dto';
import { ProjectAdministrationControllerService } from '@app/generated/api/projectAdministrationController.service';
import { ProjectUserReportDto } from '@app/generated/model';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private projectAdministrationController: ProjectAdministrationControllerService) {}

  addProject(project: ProjectDto): Observable<void> {
    return this.projectAdministrationController.createProject(project as any);
  }

  loadProjects(): Observable<ProjectDto[]> {
    return this.projectAdministrationController.getProjects() as Observable<ProjectDto[]>;
  }

  loadProject(projectId: string): Observable<ProjectDto> {
    return this.projectAdministrationController.getProject(projectId) as Observable<ProjectDto>;
  }

  updateProject(project: ProjectDto): Observable<void> {
    return this.projectAdministrationController.updateProject(project.id, project as any);
  }

  loadProjectUserReport(): Observable<ProjectUserReportDto[]> {
    return this.projectAdministrationController.getUserReport() as Observable<ProjectUserReportDto[]>;
  }
}
